import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const idBadge: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.922-3.094q.077.424.078.922c0 .336-.102.617-.297.844A.89.89 0 0 1 7-1H3a.93.93 0 0 1-.719-.328q-.28-.34-.281-.844 0-.498.063-.922.075-.42.234-.812.169-.387.484-.61a1.2 1.2 0 0 1 .75-.234c.414.398.907.594 1.469.594q.843.002 1.469-.594.433 0 .75.234.328.223.484.61.154.391.219.812m-1.656-4.39q.528.516.53 1.25-.002.738-.53 1.265A1.72 1.72 0 0 1 5-4.453q-.738 0-1.266-.516a1.72 1.72 0 0 1-.53-1.265q-.001-.734.53-1.25A1.75 1.75 0 0 1 5-8q.75 0 1.266.516M9 .75V-10H1V.75c0 .07.023.129.078.172.05.05.11.078.172.078h7.5q.106 0 .172-.078A.22.22 0 0 0 9 .75m1-11.5V.75q0 .514-.375.875A1.17 1.17 0 0 1 8.75 2h-7.5q-.515 0-.89-.375A1.19 1.19 0 0 1 0 .75v-11.5c0-.344.117-.633.36-.875Q.734-12 1.25-12H4v.75q0 .111.063.188.075.063.187.062h1.5q.106 0 .172-.062A.26.26 0 0 0 6-11.25V-12h2.75c.344 0 .633.125.875.375q.375.361.375.875m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "10",
  }
};
